import Heading from './heading';

export * from './heading';

export default Heading;
